import { Alert } from '@material-ui/lab';
import React, { useState, useEffect, ReactNode } from 'react';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import CampaignIcon from '@mui/icons-material/Campaign';
import { Grid } from '@material-ui/core';
import { Banner, useBanner } from './bannerContext';

interface BannerProps {
  announcementText: ReactNode;
  announcementUUID: string;
  bannerSeverity: string;
}

const BannerWidget: React.FC<BannerProps> = ({
  announcementText,
  bannerSeverity,
  announcementUUID,
}) => {
  const { getBanner, updateBanner } = useBanner();
  const [bannerContext, setBannerContext] = useState<Banner>({});

  useEffect(() => {
    const context = getBanner();
    setBannerContext(context.banner);
  }, [getBanner]);

  function returnBannerColor() {
    switch (bannerSeverity) {
      case 'success':
        return '#9cd59b';
      case 'warning':
        return '#fac70d';
      default:
        return '#9cd59b';
    }
  }

  function returnIconColor() {
    switch (bannerSeverity) {
      case 'success':
        return 'blue';
      case 'warning':
        return 'black';
      default:
        return 'blue';
    }
  }

  const isSameUUID = bannerContext.bannerUUID === announcementUUID;

  const renderBanner = () => {
    if (bannerContext.hasBeenSeen === undefined) {
      return null;
    }
    const output =
      !isSameUUID || !bannerContext.hasBeenSeen ? (
        <Grid direction="row">
          <Alert
            icon={
              <CampaignIcon
                style={{ color: returnIconColor() }}
                fontSize="inherit"
              />
            }
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  updateBanner({
                    hasBeenSeen: true,
                    bannerUUID: announcementUUID,
                  });
                }}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
            style={{ marginBottom: '20px', background: returnBannerColor() }}
          >
            {announcementText}
          </Alert>
        </Grid>
      ) : null;

    return output;
  };

  return <>{renderBanner()}</>;
};

export default BannerWidget;
